import { Grid } from '@mui/material';

import { disabledFutureDate } from '../../../../../../../helpers';
import {
  FormRadioGroupField,
  QuestionnaireSectionLabel,
  CLIENT_SEX_OPTIONS,
  PRIMARY_LANGUAGE_OPTIONS,
} from '../../../../../common';
import { FormAutocompleteField, FormDateField, FormTextField } from '../../../../../../common';
import { RELATIONSHIP_TO_CLIENT_OPTIONS } from '../constants';
import { US_STATE_OPTIONS } from '../../../../../../../constants';

import type { GeneralInformationFieldsProps } from './types';

export default function GeneralInformationFields({
  formik,
  disabled,
  saveFieldOnBlur,
}: GeneralInformationFieldsProps) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <FormTextField
            disabled={disabled}
            formik={formik}
            label="Your name"
            name="provider_full_name"
            onBlur={saveFieldOnBlur}
            placeholder="First and last name"
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormAutocompleteField
            disabled={disabled}
            formik={formik}
            label="Primary language spoken in the home"
            name="primary_language"
            onChange={saveFieldOnBlur}
            options={PRIMARY_LANGUAGE_OPTIONS}
            placeholder="Select a language"
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTextField
            disabled={disabled}
            formik={formik}
            label="Email address"
            name="provider_email"
            onBlur={saveFieldOnBlur}
            placeholder="Enter your email"
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormAutocompleteField
            disabled={disabled}
            formik={formik}
            label="Relationship to child"
            name="relationship_to_client"
            onChange={saveFieldOnBlur}
            options={RELATIONSHIP_TO_CLIENT_OPTIONS}
            placeholder="Select relationship"
            required
          />
        </Grid>
      </Grid>

      <QuestionnaireSectionLabel variant="h6">Child information</QuestionnaireSectionLabel>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <FormTextField
            disabled={disabled}
            formik={formik}
            label="Child legal first name"
            name="client_first_name"
            onBlur={saveFieldOnBlur}
            placeholder="Enter child first name"
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTextField
            disabled={disabled}
            formik={formik}
            label="Child legal last name"
            name="client_last_name"
            onBlur={saveFieldOnBlur}
            placeholder="Enter child last name"
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTextField
            disabled={disabled}
            formik={formik}
            label="Child legal middle name"
            name="client_middle_name"
            onBlur={saveFieldOnBlur}
            placeholder="Enter child middle name"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormDateField
            disabled={disabled}
            disabledDate={disabledFutureDate}
            formik={formik}
            label="Child date of birth"
            name="client_date_of_birth"
            onChange={saveFieldOnBlur}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormRadioGroupField
            disabled={disabled}
            formik={formik}
            label="Child gender"
            name="client_sex"
            onChange={saveFieldOnBlur}
            options={CLIENT_SEX_OPTIONS}
            required
          />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <FormTextField
            disabled={disabled}
            formik={formik}
            label="Child street address line one"
            name="client_street_address_line_one"
            onBlur={saveFieldOnBlur}
            placeholder="Enter street address"
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTextField
            disabled={disabled}
            formik={formik}
            label="Child address line two (Apartment/unit)"
            name="client_street_address_line_two"
            onBlur={saveFieldOnBlur}
            placeholder="Enter apartment/unit"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <FormTextField
            disabled={disabled}
            formik={formik}
            label="Child city"
            name="client_street_address_city"
            onBlur={saveFieldOnBlur}
            placeholder="Enter city"
            required
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormAutocompleteField
            disabled={disabled}
            formik={formik}
            label="Child state"
            name="client_street_address_state"
            onChange={saveFieldOnBlur}
            options={US_STATE_OPTIONS}
            placeholder="Select state"
            required
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormTextField
            disabled={disabled}
            formik={formik}
            label="Child zip code"
            name="client_street_address_zip"
            onBlur={saveFieldOnBlur}
            placeholder="Enter 5 digits zip code"
            required
          />
        </Grid>
      </Grid>
    </>
  );
}
